<template>
  <modal
    ref="addDowntime"
    :ok-disabled="loading"
    :ok-title="!edit ? 'Pridať' : 'Upraviť'"
    :title="!edit ? 'Nová udalosť' : 'Upraviť udalosť'"
    cancel-title="Zrušiť"
    full-height
    name="add-downtime"
    scrollable
    size="md"
    type="from-right"
    @hidden="Object.assign($data, $options.data())"
    @ok="save"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" ref="scroll" v-bar>
          <div>
            <b-form-group label="Od" label-cols-sm="5" label-for="from">
              <single-date
                v-model="form.from"
                v-validate="'required'"
                format="DD.MM.YYYY - HH:mm"
                parse-format="YYYY-MM-DD HH:mm"
                :class="{ 'is-invalid': errors.has('from') }"
                data-vv-as="Od"
                name="from"
              />
              <b-form-invalid-feedback>
                {{ errors.first('from') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Do" label-cols-sm="5" label-for="to">
              <single-date
                v-model="form.to"
                v-validate="'required'"
                format="DD.MM.YYYY - HH:mm"
                parse-format="YYYY-MM-DD HH:mm"
                :class="{ 'is-invalid': errors.has('to') }"
                data-vv-as="Do"
                name="to"
              />
              <b-form-invalid-feedback>
                {{ errors.first('to') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Záznam"
              label-cols-sm="5"
              label-for="description"
            >
              <b-form-textarea
                v-model="form.description"
                v-validate="'required'"
                rows="4"
                data-vv-as="Záznam"
                name="description"
              />
              <b-form-invalid-feedback>
                {{ errors.first('description') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
import SingleDate from '@/components/inputs/SingleDate.vue'

export default {
  components: {
    SingleDate,
    Modal,
  },
  data() {
    return {
      loading: false,
      edit: false,
      form: {},
    }
  },
  methods: {
    fetchData() {
      if (this.edit) {
        this.loading = true
        this.$api.get(`downtimes/${this.form.id}`).then((res) => {
          this.form = res.data
          this.loading = false
        })
      }
    },
    save(e) {
      e.preventDefault()
      this.$validator.validateAll().then(() => {
        if (!this.errors.any() && !this.loading) {
          this.$api
            .post(this.edit ? 'downtimes/edit' : 'downtimes/add', this.form)
            .then((res) => {
              this.$swal({
                type: 'success',
                position: 'top',
                showCloseButton: true,
                text: res.data.success,
                timer: 5000,
              })
              this.$root.$emit('modal-hide', 'add-downtime')
              this.$root.$emit('reloadDowntimesData')
            })
        } else {
          this.$swal({
            type: 'warning',
            position: 'top',
            showCloseButton: true,
            text: 'Formulár nieje správne vyplnený',
            timer: 5000,
          })
        }
      })
    },
  },
}
</script>
